import { ok } from '@oazapfts/runtime';
import * as rq from '@tanstack/react-query';

import { FeApi, useInjectFeApiContext } from '@/api/fe-api';

export namespace ClearSystemLogsCache {
  export type Input = void;
  export type Output = void;

  export function useMutation() {
    const queryClient = rq.useQueryClient();
    const clearSystemLogsCache = useInjectFeApiContext(
      FeApi.systemLogsV1CacheClearCreate,
    );
    return rq.useMutation<Output, unknown, Input>({
      mutationFn: async () => {
        await ok(clearSystemLogsCache({}));
      },
      async onSuccess() {
        await queryClient.invalidateQueries({
          queryKey: ['system-logs'],
        });
      },
    });
  }
}
